// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".game-container[data-v-2353dd96]{padding-top:60px;max-width:1340px;margin:0 auto}.game-container .show-container-title[data-v-2353dd96]{font-size:28px;font-weight:600;color:#2f3033;line-height:40px;margin-bottom:8px}.game-list[data-v-2353dd96]{position:relative;overflow:hidden;margin-right:-25px}.bottom-loading[data-v-2353dd96]{margin-top:20px;text-align:center}", ""]);
// Exports
module.exports = exports;
